const customImageInputStyle = (theme) => ({
  hidden: { display: "none" },
  container: {
    textAlign: "center",
  },
  title: {
    margin: "auto",
    display: "flex",
    justifyContent: "flex-start",
  },
  bigAvatar: {
    marginLeft: 0,
    width: 70,
    height: 70,
    borderColor: "#bdbdbd",
    background: "#bdbdbd !important",
    borderStyle: "solid",
    borderSize: "1px",
    "&:hover": {
      cursor: "pointer",
    },
  },
  avatarThumb: {
    maxWidth: "100%",
    width: "100%",
    height: "100%",
  },
  primaryBack: {
    background: theme.palette.primary.main,
  },
  whiteBack: {
    background: "white",
  },
  errorBack: { background: theme.palette.error.main },
  groupInfo: {
    width: 256,
    height: 256,
    margin: "0 auto",
  },
});
export default customImageInputStyle;
